export default {
  title: 'Galeria',
  sections: {
    logo: 'Logótipo',
    web_images: 'Imagens da galeria para encomenda online',
  },
  toasts: {
    image_uploaded: 'Alterações guardadas com sucesso',
    image_upload_failed: 'Falha ao guardar as alterações',
  },
};
